export default "__VITE_ASSET__0d4e4b42__"